import React from "react";
import SkeletonBlock from "ui/Skeleton/components/SkeletonBlock/SkeletonBlock";
import { cn } from "helpers/style";
import styles from "./SearchProductPreview.module.scss";

const SkeletonSearchProductPreview: React.FC = () => {
  return (
    <div className={styles.searchProductPreview}>
      <div className={styles.searchProductPreviewImageContainer}>
        <SkeletonBlock
          className={cn([styles.skeleton, styles.skeletonCircle])}
        />
      </div>

      <div className={styles.searchProductPreviewInner}>
        <div
          className={cn([
            styles.searchProductPreviewLeft,
            styles.searchProductPreviewLeftSkeleton,
          ])}
        >
          <SkeletonBlock className={styles.skeleton} width="100px" />
          <SkeletonBlock className={styles.skeleton} width="400px" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonSearchProductPreview;
